import { render, staticRenderFns } from "./DetailBaseInfo.vue?vue&type=template&id=9fecbd14&scoped=true&"
import script from "./DetailBaseInfo.vue?vue&type=script&lang=js&"
export * from "./DetailBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailBaseInfo.vue?vue&type=style&index=0&id=9fecbd14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fecbd14",
  null
  
)

export default component.exports